// External libraries
import { action } from 'easy-peasy';

import type { UserActions, UserModel, UserState } from './types';

export const getUserState = (
  overrides: Partial<UserState> = {},
): UserState => ({
  // NOTE: This is set to true only after a successful
  // checkoutGuestWithMemberBenefits mutation call
  // Even 3DS 2.0 contingency thrown during the mutation
  // call will not set this to true value
  isUserGuestWithMemberBenefits: false,
  isUserLoggedIn: false,
  // Passkey context will be updated only after a successful
  // planning call. The context creation is in parallel to
  // approvePayment call
  passkey: {
    context: '',
    isAvailable: false,
    isPasswordlessFlow: false,
    returnToMerchantUrl: '',
  },
  ...overrides,
});

const createUserActions = (): UserActions => ({
  setIsPasskeyAvailable: action((state, payload) => {
    state.passkey.isAvailable = Boolean(payload);
  }),
  setIsPasskeyPasswordlessFlow: action((state, payload) => {
    state.passkey.isPasswordlessFlow = Boolean(payload);
  }),
  setIsUserGuestWithMemberBenefits: action((state, payload) => {
    state.isUserGuestWithMemberBenefits = Boolean(payload);
  }),
  setPasskeyIWCContext: action((state, payload) => {
    state.passkey.context = payload ?? '';
  }),
  setPasskeyReturnToMerchantUrl: action((state, payload) => {
    state.passkey.returnToMerchantUrl = payload ?? '';
  }),

  setUserLoggedIn: action(state => {
    state.isUserLoggedIn = true;
  }),
  setUserLoggedOut: action(state => {
    state.isUserLoggedIn = false;
  }),
});

export const userModelFactory = (): UserModel => ({
  ...getUserState(),
  ...createUserActions(),
});
